import faro from "src/shared/third-party-integrations/faro";
import Session from "Session";
import Strings from "../Strings";
import { getErrorMessage } from "../store/common/Exception";
const measurementContextPrefixGenerators = {
    batch_update_component_variables: (data) => {
        return `component.${data.componentId}`;
    },
    campaign_edit_v1_save_variables: (data) => {
        return `campaign.${data.campaignId}`;
    },
    root_campaign_save_and_publish: (data) => {
        return `campaign.${data.campaignId}`;
    },
    publish_campaign: (data) => {
        return `campaign.${data.campaignId}`;
    },
    load_all_programs: (data) => {
        return `programs.${data.clientId}`;
    },
    flow_builder_create_reward: (data) => {
        return `component.${data.componentId}`;
    },
    component_drawer_duplicate_component: (data) => {
        return `component.${data.componentId}`;
    },
    load_installed_extensions: (data) => {
        return `extensions.${data.clientId}`;
    },
    load_installed_integrations: (data) => {
        return `integrations.${data.clientId}`;
    },
    load_component_candidates: (data) => {
        return data.targetSocketName
            ? `target.${data.targetComponentId}.${data.targetSocketName}`
            : `target.${data.targetComponentId}`;
    },
    manual_reward_issue_reward: (data) => {
        return `reward.${data.clientId}`;
    },
    duplicate_campaign: (data) => {
        return `campaign.${data.campaignId}`;
    },
    deprecated_load_partners: (data) => {
        return `partners.${data.clientId}`;
    },
};
const formatFaroDurationMeasurementType = (type, data) => {
    const clientName = Strings.encodeSnakeCase(Session.getInstance().getClientName());
    const contextPrefix = measurementContextPrefixGenerators[type](data);
    return `${clientName}.${contextPrefix}.${type}_duration`;
};
export class MeasurementBuilder {
    constructor(type) {
        this.type = type;
        this.startTime = Date.now();
    }
    withData(data) {
        this.data = data;
        return this;
    }
    send() {
        if (!this.data) {
            throw new Error("Data must be provided via withData() before sending measurement");
        }
        try {
            const duration = Date.now() - this.startTime;
            const faroMeasurementType = formatFaroDurationMeasurementType(this.type, this.data);
            faro.pushMeasurement(faroMeasurementType, { duration });
        }
        catch (error) {
            faro.pushError(new Error(getErrorMessage(error)));
        }
    }
}
export const createDurationMeasurement = (type) => {
    return new MeasurementBuilder(type);
};
